import { IconRender, InheritProps } from '../IconRender';

export function GridIcon(props: InheritProps) {
  return (
    <IconRender
      {...props}
      childrenRender={(color: string) => (
        <>
          <rect x="2" y="2" width="76" height="76" rx="11" fill="#343434" stroke={color} strokeWidth="3" />
          <path
            d="M3 54H77V67C77 72.5 72.5 77 67 77H13C7.5 77 3 72.5 3 67V54Z"
            fill="#D9D9D9"
          />
          <rect x="10" y="59" width="11" height="11" rx="2" fill="#343434" />
          <rect x="26" y="59" width="11" height="11" rx="2" fill="#343434" />
          <rect x="42" y="59" width="11" height="11" rx="2" fill="#343434" />
          <rect x="58" y="59" width="11" height="11" rx="2" fill="#343434" />
        </>
      )}
    />
  );
}
